const { REACT_APP_GCP_GOOGLE_MAPS_API } = process.env

const googleMapsConfig = {
  apiKey: REACT_APP_GCP_GOOGLE_MAPS_API
}

export default googleMapsConfig
